import labels from 'src/../config/label.js'

export const mocker = {
  filepath () {
    return { filepath: '' }
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/profileimg/mocker.js